<template>
  <div id="app">
    <el-container>
      <el-header height="80px">
        <div class="header-body">
          <router-link to="/">
            <div class="logo cursor-pointer">
              <img class="h-47" src="./assets/images/logo@2x.png" />
            </div>
          </router-link>
          <div class="flex items-center flex-1 menu">
            <div
              class="flex flex-col items-center mr-40 menu-item"
              :class="{ active: type === 'index' }"
              @click="clickMenu('index')"
            >
              <div
                @click.prevent.stop="jumpRouter('/index')"
                class="h-[76px] flex items-center mt-4 cursor-pointer"
              >
                <span class="mr-5 text-[16px]">首页</span>
              </div>
              <div class="h-4 bar"></div>
            </div>
            <div
              class="flex flex-col items-center mr-40 menu-item"
              :class="{ active: type === 'product' }"
              @click="clickMenu('product')"
            >
              <div class="h-[76px] flex items-center mt-4 cursor-pointer">
                <span class="mr-5 text-[16px]">产品</span>
                <i class="el-icon-arrow-down text-[14px] font-bold"></i>
              </div>
              <div class="h-4 bar"></div>
              <div
                class="menu-content fixed top-80 z-10 bg-white w-full flex justify-center duration-300"
                :style="{ opaticy: type === 'product' ? '1' : '0' }"
              >
                <div class="w-[1240px] h-[280px] pt-40 flex justify-between">
                  <div
                    @click.prevent.stop="jumpRouter('/detail-sjzlpt')"
                    class="sub-item text-black w-[350px] h-120 px-[30px] py-[10px] rounded-[4px] m-10 cursor-pointer"
                  >
                    <div class="flex items-center mb-10">
                      <div class="w-48 h-48 relative">
                        <img
                          class="w-48 h-48 rounded-[4px] absolute left-0 top-0 icon1"
                          src="./assets/images/head_product1.png"
                          alt=""
                        />
                        <img
                          class="w-34 h-34 rounded-[4px] absolute left-6 top-6 icon2"
                          src="./assets/images/head_product1_active.png"
                          alt=""
                        />
                      </div>
                      <div class="font-shs-medium f20 sub-item-text">
                        蓝晶数据治理平台
                      </div>
                    </div>
                    <div class="color-sub">{{ GlobalJson[1].c[0].t }}</div>
                  </div>
                  <div
                    @click.prevent.stop="jumpRouter('/detail-sjzt')"
                    class="sub-item text-black w-[350px] h-120 px-[30px] py-[10px] rounded-[4px] m-10 cursor-pointer"
                  >
                    <div class="flex items-center mb-10">
                      <div class="w-48 h-48 relative">
                        <img
                          class="w-48 h-48 rounded-[4px] absolute left-0 top-0 icon1"
                          src="./assets/images/head_product2.png"
                          alt=""
                        />
                        <img
                          class="w-34 h-34 rounded-[4px] absolute left-6 top-6 icon2"
                          src="./assets/images/head_product2_active.png"
                          alt=""
                        />
                      </div>
                      <div class="font-shs-medium f20 sub-item-text">
                        蓝晶数据中台
                      </div>
                    </div>
                    <div class="color-sub">{{ GlobalJson[1].c[1].t }}</div>
                  </div>
                  <div
                    @click.prevent.stop="jumpRouter('/detail-htbi')"
                    class="sub-item text-black w-[350px] h-120 px-[30px] py-[10px] rounded-[4px] m-10 cursor-pointer"
                  >
                    <div class="flex items-center mb-10">
                      <div class="w-48 h-48 relative">
                        <img
                          class="w-48 h-48 rounded-[4px] absolute left-0 top-0 icon1"
                          src="./assets/images/head_product3.png"
                          alt=""
                        />
                        <img
                          class="w-34 h-34 rounded-[4px] absolute left-6 top-6 icon2"
                          src="./assets/images/head_product3_active.png"
                          alt=""
                        />
                      </div>
                      <div class="font-shs-medium f20 sub-item-text">
                        宏图BI
                      </div>
                    </div>
                    <div class="color-sub">{{ GlobalJson[1].c[2].t }}</div>
                  </div>
                  <div
                    @click.prevent.stop="jumpRouter('/detail-wyddm')"
                    class="sub-item text-black w-[350px] h-120 px-[30px] py-[10px] rounded-[4px] m-10 cursor-pointer"
                  >
                    <div class="flex items-center mb-10">
                      <div class="w-48 h-48 relative">
                        <img
                          class="w-48 h-48 rounded-[4px] absolute left-0 top-0 icon1"
                          src="./assets/images/head_product4.png"
                          alt=""
                        />
                        <img
                          class="w-34 h-34 rounded-[4px] absolute left-6 top-6 icon2"
                          src="./assets/images/head_product4_active.png"
                          alt=""
                        />
                      </div>
                      <div class="font-shs-medium f20 sub-item-text">
                        纬业低代码平台
                      </div>
                    </div>
                    <div class="color-sub">{{ GlobalJson[1].c[3].t }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="flex flex-col items-center mr-40 menu-item"
              :class="{ active: type === 'solution' }"
              @click="clickMenu('solution')"
            >
              <div class="h-[76px] flex items-center mt-4 cursor-pointer">
                <span class="mr-5 text-[16px]">解决方案</span>
                <i class="el-icon-arrow-down text-[14px] font-bold"></i>
              </div>
              <div class="h-4 bar"></div>
              <div
                class="menu-content fixed top-80 z-10 bg-white w-full flex justify-center duration-300"
                :style="{ opaticy: type === 'solution' ? '1' : '0' }"
              >
                <div class="w-full h-[280px] flex">
                  <div class="w-260 h-full bg-[#7FBAF0] bg-opacity-10 ">
                    <div
                      @mouseenter="solutionType = 'key_trades'"
                      :class="
                        solutionType == 'key_trades'
                          ? 'bg-opacity-20 bg-[#7FBAF0]'
                          : ''
                      "
                      class="h-70 flex  items-center justify-center cursor-pointer  transition-300 hover:bg-[#7FBAF0] hover:bg-opacity-20 style1"
                    >
                      <img
                        class="w-24 h-24 mr-10"
                        src="./assets/images/zdhyjjfa/zdhyjjfa.png"
                        alt=""
                      />
                      <div
                        class="name text-black text-[20px] mr-10 font-shs-medium"
                        :class="
                          solutionType == 'key_trades' ? 'active-color' : ''
                        "
                      >
                        重点行业解决方案
                      </div>
                      <i
                        class="el-icon-arrow-right text-[18px] text-black font-bold  name"
                        :class="
                          solutionType == 'key_trades' ? 'active-color' : ''
                        "
                      ></i>
                    </div>
                    <div
                      @mouseenter="solutionType = 'general_industry'"
                      :class="
                        solutionType == 'general_industry'
                          ? 'bg-opacity-20 bg-[#7FBAF0]'
                          : ''
                      "
                      class="h-70 flex items-center justify-center cursor-pointer  transition-300 hover:bg-[#7FBAF0] hover:bg-opacity-20 style1"
                    >
                      <img
                        class="w-36 h-36 mr-10"
                        src="./assets/images/smart_city.png"
                        alt=""
                      />
                      <div
                        class="name text-black text-[20px] mr-10 font-shs-medium"
                        :class="
                          solutionType == 'general_industry'
                            ? 'active-color'
                            : ''
                        "
                      >
                        通用行业解决方案
                      </div>
                      <i
                        class="el-icon-arrow-right text-[18px] text-black font-bold  name"
                        :class="
                          solutionType == 'general_industry'
                            ? 'active-color'
                            : ''
                        "
                      ></i>
                    </div>
                    <!-- <div @mouseenter="solutionType = 'smart_city'" class="h-70 flex items-center justify-center cursor-pointer bg-transparent transition-300 hover:bg-[#7FBAF0] hover:bg-opacity-20 style1">
                      <img class="w-36 h-36 mr-10" src="./assets/images/smart_city.png" alt="">
                      <div class="name text-black text-[20px] mr-10 font-shs-medium">智慧城市</div>
                      <i class="el-icon-arrow-right text-[12px] font-bold"></i>
                    </div> -->
                    <!-- <div @mouseenter="solutionType = 'communication_industry'" class="h-70 flex items-center justify-center cursor-pointer bg-transparent transition-300 hover:bg-[#7FBAF0] hover:bg-opacity-20 style1">
                      <img class="w-36 h-36 mr-10" src="./assets/images/communication_industry.png" alt="">
                      <div class="name text-black text-[20px] mr-10 font-shs-medium">通信行业</div>
                      <i class="el-icon-arrow-right text-[12px] font-bold"></i>
                    </div> -->
                  </div>
                  <!-- 重点行业解决方案  -->
                  <div
                    v-if="solutionType === 'key_trades'"
                    class="flex-1 pl-2 pt-26"
                  >
                    <div class="flex flex-wrap  f18">
                      <div
                        v-for="(item, index) in keyTradesSolutionList"
                        :key="index"
                        class="w-1/5 h-70 pl-72 ] cursor-pointer "
                      >
                        <div
                          class="  pb-10 border-b-[1px] border-[#999999] text-[#999999]"
                        >
                          <h3>{{ item.name }}</h3>
                        </div>
                        <ul>
                          <li
                            v-for="(subItem, subIndex) in item.subItemList"
                            :key="subIndex"
                            class="cursor-pointer  text-[16px] mt-20 text-black"
                            :class="
                              activeIndex == subIndex ? 'active-style' : ''
                            "
                            @mouseenter="activeIndex = subIndex"
                            @click.prevent.stop="
                              jumpRouter(
                                '/solution-ppt-detail',
                                subItem,
                                'zdhyjjfa'
                              )
                            "
                          >
                            {{ subItem.name }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <!-- 通用行业解决方案  -->
                  <div
                    v-if="solutionType === 'general_industry'"
                    class="flex-1 pl-2 pt-26"
                  >
                    <div class="flex flex-wrap text-[#B4B9BF] f18">
                      <div
                        v-for="(item, index) in generalIndustrySolutionList"
                        :key="index"
                        class="w-1/4 h-70 pl-72 ] cursor-pointer "
                      >
                        <h3
                          :class="activeIndex == index ? 'active-style' : ''"
                          @mouseenter="activeIndex = index"
                          class="text-black "
                          @click.prevent.stop="
                            jumpRouter('/solution-ppt-detail', item, 'tyhyjjfa')
                          "
                        >
                          {{ item.name }}
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="flex flex-col items-center mr-40 menu-item"
              :class="{ active: type === 'case' }"
              @click="clickMenu('case')"
            >
              <div
                @click.prevent.stop="jumpRouter('/case-list')"
                class="h-[76px] flex items-center mt-4 cursor-pointer"
              >
                <span class="mr-5 text-[16px]">客户案例</span>
              </div>
              <div class="h-4 bar"></div>
            </div>
            <!-- <div class="flex flex-col items-center mr-40 menu-item" :class="{ active: type === 'server'}" @click="clickMenu('server')">
              <div class="h-[76px] flex items-center mt-4 cursor-pointer">
                <span class="mr-5 text-[16px]">服务中心</span>
              </div>
              <div class="h-4 bar"></div>
            </div> -->
            <div
              class="flex flex-col items-center relative mr-40 menu-item"
              :class="{ active: type === 'about' }"
              @click="clickMenu('about')"
            >
              <div class="h-[76px] flex items-center mt-4 cursor-pointer">
                <span class="mr-5 text-[16px]">关于君南</span>
                <i class="el-icon-arrow-down text-[14px] font-bold"></i>
              </div>
              <div class="h-4 bar"></div>
              <div
                class="menu-content absolute top-84 z-10 bg-white h-140 w-240 flex duration-300"
                :style="{ opaticy: type === 'about' ? '1' : '0' }"
              >
                <div class="w-full">
                  <div
                    @click.prevent.stop="jumpRouter('/about')"
                    class="h-70 w-full flex items-center justify-center cursor-pointer text-[20px] text-black font-shs-medium hover:bg-[#7FBAF0] hover:bg-opacity-20 hover:text-[#144DA0]"
                  >
                    君南介绍
                  </div>
                  <div
                    @click.prevent.stop="jumpRouter('/recruitment')"
                    class="h-70 w-full flex items-center justify-center cursor-pointer text-[20px] text-black font-shs-medium hover:bg-[#7FBAF0] hover:bg-opacity-20 hover:text-[#144DA0]"
                  >
                    加入我们
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex items-center">
            <img class="w-26 h-26" src="./assets/images/phone_blue.png" />
            <div class="f16 text-black ml-16">193-9688-4812</div>
          </div>
        </div>
      </el-header>
      <el-main style="padding-top: 80px !important; overflow-x: hidden;">
        <router-view />
      </el-main>
      <div class="footer" v-show="isShow">
        <div class="footer-content">
          <ul class="content-nav">
            <li>
              <p>产品中心</p>
              <span @click="$router.push('/detail-sjzlpt')"
                >蓝晶数据治理平台</span
              >
              <span @click="$router.push('/detail-sjzt')">蓝晶数据中台</span>
              <span @click="$router.push('/detail-htbi')">宏图BI</span>
              <span @click="$router.push('/detail-wyddm')">纬业低代码平台</span>
            </li>
            <li>
              <p>重点行业解决方案</p>
              <div class="flex justify-between w-[220px]">
                <div class="left w-[100px]">
                  <p class="bottom-border">政务</p>
                  <span
                    class="block cursor-pointer"
                    @click.prevent.stop="
                      jumpRouter(
                        '/solution-ppt-detail',
                        { name: '智慧财政', type: 'zhcz', num: 33 },
                        'zdhyjjfa'
                      )
                    "
                    >智慧财政</span
                  >
                  <span
                    class="block cursor-pointer"
                    @click.prevent.stop="
                      jumpRouter(
                        '/solution-ppt-detail',
                        { name: '智慧园区', type: 'zhyq', num: 41 },
                        'zdhyjjfa'
                      )
                    "
                    >智慧园区</span
                  >
                </div>
                <div class="right w-[100px]">
                  <p class="bottom-border">能源</p>
                  <span
                    class="block cursor-pointer"
                    @click.prevent.stop="
                      jumpRouter(
                        '/solution-ppt-detail',
                        { name: '智慧运维', type: 'zhyw', num: 47 },
                        'zdhyjjfa'
                      )
                    "
                    >智慧运维</span
                  >
                  <span
                    class="block cursor-pointer"
                    @click.prevent.stop="
                      jumpRouter(
                        '/solution-ppt-detail',
                        { name: '智慧能耗', type: 'zhnh', num: 34 },
                        'zdhyjjfa'
                      )
                    "
                    >智慧能耗</span
                  >
                </div>
              </div>
              <div class="flex justify-between w-[220px]">
                <div class="left w-[100px]">
                  <p class="bottom-border">制造</p>
                  <span
                    class="block cursor-pointer"
                    @click.prevent.stop="
                      jumpRouter(
                        '/solution-ppt-detail',
                        { name: '生产流程管理', type: 'sclcgl', num: 31 },
                        'zdhyjjfa'
                      )
                    "
                    >生产流程管理</span
                  >
                  <span
                    class="block cursor-pointer"
                    @click.prevent.stop="
                      jumpRouter(
                        '/solution-ppt-detail',
                        { name: '资产管理系统', type: 'zcglxt', num: 26 },
                        'zdhyjjfa'
                      )
                    "
                    >资产管理系统</span
                  >
                  <span
                    class="block cursor-pointer"
                    @click.prevent.stop="
                      jumpRouter(
                        '/solution-ppt-detail',
                        { name: '客户管理系统', type: 'khglxt', num: 35 },
                        'zdhyjjfa'
                      )
                    "
                    >客户管理系统</span
                  >
                </div>
                <div class="right w-[100px]">
                  <p class="bottom-border">应急</p>
                  <span
                    class="block cursor-pointer"
                    @click.prevent.stop="
                      jumpRouter(
                        '/solution-ppt-detail',
                        { name: '智慧矿山', type: 'zhks', num: 44 },
                        'zdhyjjfa'
                      )
                    "
                    >智慧矿山</span
                  >
                  <span
                    class="block cursor-pointer"
                    @click.prevent.stop="
                      jumpRouter(
                        '/solution-ppt-detail',
                        { name: '智慧水利', type: 'zhsl', num: 34 },
                        'zdhyjjfa'
                      )
                    "
                    >智慧水利</span
                  >
                  <span
                    class="block cursor-pointer"
                    @click.prevent.stop="
                      jumpRouter(
                        '/solution-ppt-detail',
                        { name: '智慧水上卡口', type: 'zhsskl', num: 30 },
                        'zdhyjjfa'
                      )
                    "
                    >智慧水上卡口</span
                  >
                </div>
              </div>
              <!-- <span @click="$router.push({path:'/solution-ppt-detail',query:{num:41,type:'zhyq',parentMenu:'zdhyjjfa'}})">智慧园区</span> -->
              <!-- <span>智慧环卫</span>
              <span>智慧停车</span>
              <span>智慧能源</span>
              <span>智慧环保</span> -->
            </li>
            <li>
              <p>通用行业解决方案</p>
              <span
                 class="block cursor-pointer"
                v-for="(item, index) in generalIndustrySolutionList"
                :key="index"
                 @click.prevent.stop="
                      jumpRouter(
                        '/solution-ppt-detail',
                       item,
                        'tyhyjjfa'
                      )
                    "
                >{{ item.name }}</span
              >
            </li>
            <li>
              <p>关于君南</p>
              <span @click="$router.push('/about')">了解君南</span>
              <span @click="$router.push('/recruitment')">加入君南</span>
              <span>合作客户</span>
            </li>
          </ul>
          <div class="">
            <div style="font-size: 18px">联系我们</div>
            <div class="mt-28">
              <div class="flex items-center mb-8">
                <div class="w-24 h-24 mr-15">
                  <img
                    class="w-full h-full object-contain mr-10"
                    src="./assets/images/phone_white.png"
                    alt=""
                  />
                </div>
                <div class="text-20px">电话：020-8251-9914</div>
              </div>
              <div class="flex items-center mb-8">
                <div class="w-24 h-24 mr-15"></div>
                <div class="text-20px">手机：193-9688-4812</div>
              </div>
            </div>
            <div class="mt-28">
              <div class="flex items-center mb-8">
                <div class="w-24 h-24 mr-15">
                  <img
                    class="w-full h-full object-contain"
                    src="./assets/images/email.png"
                    alt=""
                  />
                </div>
                <div class="text-20px">产品建议邮箱:</div>
              </div>
              <div class="flex items-center mb-8">
                <div class="w-24 h-24 mr-15"></div>
                <div class="text-20px">chanpin@junnanxinxi.com</div>
              </div>
            </div>
          </div>
        </div>
        <div class="foot-bottom">
          <div class="policy-content">
            <div class="policy">隐私声明</div>
            <div class="policy">免责声明</div>
          </div>
          <div class="copyright">
            <span
              >版权所有 Ⓒ深圳君南信息系统有限公司 版权所有
              <a href="https://beian.miit.gov.cn" target="_blank"
                >粤ICP备10084129号</a
              ></span
            >
          </div>
        </div>
      </div>
      <div
        class="fixed right-86 bottom-86 cursor-pointer z-100"
        @click="clickService"
      >
        <img class="w-175 h-86" src="./assets/images/customer_service.png" />
        <div class="absolute right-45 top-21 text-white f24">咨询</div>
      </div>
    </el-container>
  </div>
</template>

<script>
import GlobalJson from './json/index.json'
export default {
  data() {
    return {
      GlobalJson,
      router: true,
      defaultActive: '/',
      isShow: true,
      type: '',
      solutionType: 'key_trades',
      activeIndex: '',
      keyTradesSolutionList: [
        //重点行业解决方案  type是名字的首字母拼音
        {
          name: '政务',
          subItemList: [
            { name: '智慧财政', type: 'zhcz', num: 33 },
            { name: '智慧园区', type: 'zhyq', num: 41 }
          ]
        },
        {
          name: '能源',
          subItemList: [
            { name: '智慧运维', type: 'zhyw', num: 47 },
            { name: '智慧能耗', type: 'zhnh', num: 34 }
          ]
        },
        {
          name: '制造',
          subItemList: [
            { name: '生产流程管理', type: 'sclcgl', num: 31 },
            { name: '资产管理系统', type: 'zcglxt', num: 26 },
            { name: '客户管理系统', type: 'khglxt', num: 35 }
          ]
        },
        {
          name: '应急',
          subItemList: [
            { name: '智慧矿山', type: 'zhks', num: 44 },
            { name: '智慧水利', type: 'zhsl', num: 34 },
            { name: '智慧水上卡口', type: 'zhsskk', num: 30 }
          ]
        }
      ],
      generalIndustrySolutionList: [
        //通用行业解决方案  type是名字的首字母拼音
        { name: '智慧会议', type: 'zhhy', num: 32 },
        { name: '政企客户管理', type: 'zqkhgl', num: 32 },
        { name: '文档智能中台', type: 'wdznzt', num: 27 },
        { name: '智慧物业', type: 'zhwy', num: 41 },
        { name: '智慧办公', type: 'zhbg', num: 32 },
        { name: '数字孪生', type: 'szls', num: 31 },
        { name: '安全调度管理平台', type: 'aqddglpt', num: 23 },
        { name: '智慧巡检', type: 'zhxj', num: 25 }
      ]
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll) // 记得在组件销毁前移除事件监听器
  },
  methods: {
    handleScroll() {
      this.type = '' // 在滚动事件触发时将type设为空字符串
    },
    // 跳转路由地址 query参数 parentMenu zdhyjjfa重点行业解决方案  tyhyjjfa通用行业解决方案
    jumpRouter(route, query, parentMenu) {
      // 由于重点行业解决方案和通用行业解决方案有些菜单没有PPT图片 所以这里加判断不让跳转
      if (query) {
        if (!query.num) {
          return false
        } else {
          // 给参数中增加图片的父级菜单
          query.parentMenu = parentMenu
        }
      }
      this.type = ''
      this.$router.push({ path: route, query: query })
    },
    clickMenu(type) {
      this.type = type
    },
    handleSelect(key) {
      this.isShow = this.defaultActive != key
      window.console.log(this.isShow)
    },
    clickService() {
      window.open(
        'https://work.weixin.qq.com/kfid/kfc22af7e7b50d30b9b',
        '_blank'
      )
    }
  }
}
</script>
<style scoped lang="scss">
.font-bold {
  font-weight: bold !important;
}
.active-color {
  color: #144da0;
}
.active-style:hover {
  // color: #144DA0;
  color: #144da0;
}
</style>
<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: Source Han Sans CN-Regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
}

.el-header {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 100;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  //background-color: #fff;
  .header-body {
    width: 1240px;
    display: flex;
    align-content: center;
    justify-content: space-between;
    .logo {
      height: 47px;
      margin-right: 40px;
      margin-top: 20px;
      img {
        width: 100%;
      }
    }
    .phone {
    }
  }
}
.menu-item {
  border-bottom: 4px solid transparent;
  transition: 0.3s;
  position: relative;
  .bar {
    width: 0%;
    background-color: #045fb2;
    transition: 0.2s;
  }
  .menu-content {
    opacity: 0; /* 默认隐藏 */
    pointer-events: none; /* 防止未显示时触发 hover 事件 */
    transition: opacity 0.4s ease; /* 添加过渡效果 */
    left: 50%;
    transform: translateX(-50%);
    box-shadow: -4px 44px 40px -24px rgba(0, 0, 0, 0.1);
    .sub-item {
      position: relative;
      background: #fff;
      transition: 0.2s;
      .icon1 {
        opacity: 1;
        transition: 0.2s;
      }
      .icon2 {
        opacity: 0;
        transition: 0.2s;
      }
      .color-sub {
        color: #666;
        font-size: 12px;
        font-family: 'DIN Medium';
      }
    }
    /* 渐变背景层 */
    .sub-item::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(127, 185, 240, 0.15) 100%
      );
      box-shadow: 0px 6px 7px 0px rgba(3, 22, 50, 0.1);
      opacity: 0;
      transition: opacity 0.4s ease-out;
    }

    /* 触发动画 */
    .sub-item:hover::before,
    .sub-item:focus-within::before {
      opacity: 1;
    }
    .sub-item:hover,
    .sub-item:focus-within {
      .icon1 {
        opacity: 0;
      }
      .icon2 {
        opacity: 1;
      }
      .sub-item-text {
        color: #2a66be;
      }
    }
  }
}
.menu-item:hover {
  color: #045fb2;
  span {
    color: #045fb2;
  }
  .bar {
    width: 100%;
  }
  .menu-content {
    opacity: 1; /* 悬停时显示 */
    pointer-events: auto; /* 显示后允许触发 hover 事件 */
  }
}
.active {
  span {
    color: #045fb2;
  }
  .bar {
    width: 100%;
    background-color: #045fb2;
  }
  .menu-content {
    opacity: 1; /* 悬停时显示 */
    pointer-events: auto; /* 显示后允许触发 hover 事件 */
  }
}
.style1:hover {
  .name {
    color: #144da0;
  }
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  height: 430px;
  color: #fff;
  overflow: hidden;
  background-color: #050f19;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 40px;
    padding-bottom: 30px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 18px;
          color: #fff;
          height: 50px;
          line-height: 50px;
        }
        span {
          color: #748ea6;
          font-size: 16px;
          font-weight: 500;
          padding: 6px 0;
          cursor: pointer;
        }
        span:hover {
          color: #045fb2;
        }
      }
    }
  }
  .foot-bottom {
    height: 95px;
    width: 100%;
    border-top: 1px solid #293a49;
    color: #748ea6;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .policy-content {
      display: flex;
      align-items: center;
      justify-content: center;
      .policy {
        margin: 0px 28px;
      }
      .policy:hover {
        color: #045fb2;
        cursor: pointer;
      }
    }
    .copyright {
      height: 30px;
      span {
        line-height: 30px;
      }
      a:hover {
        color: #045fb2;
      }
    }
  }
}
.bottom-border {
  border-bottom: 2px solid #343b42;
}
</style>
